
import React, { useState, useEffect } from "react";
import axios from 'axios';
import './product.css';
import plus from '../assets/images/plus.png';
import AddProduct from "./AddProduct";

const Product = () => {
  const [products, setProducts] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [searchCriteria, setSearchCriteria] = useState("");
  const [selectedProduct, setSelectedProduct] = useState(null); // For edit

  useEffect(() => {
    fetchProducts();
  }, []);

  const fetchProducts = async () => {
    try {
      const response = await axios.get('https://backend-n2zq.onrender.com/Productdetails');
      console.log('Received data:', response.data);
      if (response.data) {
        setProducts(response.data);
      } else {
        console.error('Invalid data format');
        setProducts([]);
      }
    } catch (error) {
      console.error('Error fetching product data:', error);
      setProducts([]);
    }
  };


const handleProductAddOrUpdate = async (formData) => {
    try {
        if (selectedProduct) {
            // Update existing product
            await axios.put(`https://backend-n2zq.onrender.com/Productdetails/${selectedProduct._id}`, formData, {
                headers: { "Content-Type": "multipart/form-data" },
            });
        } else {
            // Add new product
            await axios.post('https://backend-n2zq.onrender.com/Productdetails', formData, {
                headers: { "Content-Type": "multipart/form-data" },
            });
        }
        fetchProducts();
        setIsModalOpen(false);
        setSelectedProduct(null);
    } catch (error) {
        console.error('Error adding/updating product:', error);
    }
};


  const handleDelete = async (id) => {
    try {
      await axios.delete(`https://backend-n2zq.onrender.com/Productdetails/${id}`);
      fetchProducts();
    } catch (error) {
      console.error('Error deleting product:', error);
    }
  };

  const handleEdit = (product) => {
    setSelectedProduct(product);
    setIsModalOpen(true);
  };

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value.toLowerCase());
  };

  const handleCriteriaChange = (e) => {
    setSearchCriteria(e.target.value);
  };

  const filteredProducts = Array.isArray(products)
    ? products.filter((product) => {
        let matchesSearchQuery = true;
        let matchesCriteria = true;

        if (searchQuery) {
          const query = searchQuery.toLowerCase();
          matchesSearchQuery =
            (product.productname?.toLowerCase() || "").includes(query) ||
            (product.brand?.toLowerCase() || "").includes(query) ||
            (product.category?.toLowerCase()|| "").includes(query)||
            (String(product.price)?.toLowerCase() || "").includes(query);
        }

        if (searchCriteria) {
          matchesCriteria = (product.category?.toLowerCase() || "") === searchCriteria;
        }

        return matchesSearchQuery && matchesCriteria;
      })
    : [];

  console.log("products--->", products);

  return (
    <div className="page-container" style={{ width: "85vw" }}>
      <div className="list-top">
        <div className="class">
          <h3>Product ({filteredProducts.length})</h3>
        </div>
        <div className="search">
          <input
            type="text"
            placeholder="Type to Search..."
            value={searchQuery}
            onChange={handleSearchChange}
          />
        
          <select value={searchCriteria} onChange={handleCriteriaChange}>
            <option value="">All</option>
            <option value="smartphones">SMARTPHONES</option>
            <option value="laptops">LAPTOPS</option>
            <option value="fragrances">FRAGRANCES</option>
            <option value="skincare">SKINCARE</option>
            <option value="groceries">GROCERIES</option>
          </select>
        </div>

        <div className="btn-container">
          <button className="tooltip" onClick={() => setIsModalOpen(true)}>
            <img src={plus} alt="logo" />
            <span className="tooltiptext">ADD PRODUCT</span>
          </button>
        </div>
      </div>

      <div style={{ overflowY: "auto" }}>
        {filteredProducts.length > 0 ? (
          <table>
            <thead>
              <tr>
                <th>Image</th>
                <th>Product Name</th>
                <th>Brand</th>
                <th>Price</th>
                <th>Category</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {filteredProducts.map((data, index) => (
                <tr key={index}>
                  <td>
                    {data.img ? (
                      <img src={data.img} alt="Product" style={{ width: "50px", height: "50px", borderRadius: "50%" }} />
                    ) : (
                      "No image"
                    )}
                  </td>
                  <td>{data.productname}</td>
                  <td>{data.brand}</td>
                  <td>{data.price}</td>
                  <td>{data.category}</td>
                  <td> 
                    <button onClick={() => handleEdit(data)}>Edit</button>
                    <button onClick={() => handleDelete(data._id)}>Delete</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <p style={{ display: "flex", justifyContent: "center", marginTop: "60px" }}>
            No product detail available
          </p>
        )}
      </div>

      <div>
        {isModalOpen && (
          <AddProduct
            onProductAdd={handleProductAddOrUpdate}
            onClose={() => setIsModalOpen(false)}
            product={selectedProduct} // Pass selected product for editing
          />
        )}
      </div>
    </div>
  );
};

export default Product;
